import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M10 4H2v16h20V6H12l-2-2z"
}), 'FolderSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/FolderSharp.js
// module id = 3782
// module chunks = 2